import styled from 'styled-components';

import colors from 'themes/Main';

const { white, darkBlue } = colors;

export const Container = styled.div`
  z-index: 50;
  display: ${({ isLoading }) => (isLoading ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: ${darkBlue};
`;

export const Loader = styled.div`
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 auto;
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Clock = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  border: 3px solid ${white};
  border-radius: 60px;

  &::after {
    content: '';
    position: absolute;
    background-color: ${white};
    top: 1px;
    left: 48%;
    width: 4px;
    height: 38px;
    border-radius: 5px;
    transform-origin: 50% 96%;
    animation: minutesPointer 2s linear infinite;
  }

  &::before {
    content: '';
    position: absolute;
    background-color: ${white};
    top: 5px;
    left: 48%;
    width: 4px;
    height: 35px;
    border-radius: 5px;
    transform-origin: 50% 93%;
    animation: hoursPointer 12s linear infinite;
  }

  @keyframes minutesPointer {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes hoursPointer {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const Balls = styled.div`
  position: relative;
  margin-top: 16px;
  width: 12px;
  height: 12px;
  border-radius: 12px;
  animation: secondBall 3s ease-in-out infinite;

  &::before {
    content: '';
    position: absolute;
    top: 0px;
    left: -25px;
    height: 12px;
    width: 12px;
    border-radius: 12px;
    animation: firstBall 3s ease-in-out infinite;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0px;
    left: 25px;
    height: 10px;
    width: 10px;
    border-radius: 10px;
    animation: thirdBall 3s ease-in-out infinite;
  }

  @keyframes firstBall {
    0% {
      background-color: rgba(255, 255, 255, 0.2);
    }
    25% {
      background-color: rgba(255, 255, 255, 1);
    }
    50% {
      background-color: rgba(255, 255, 255, 0.2);
    }
    75% {
      background-color: rgba(255, 255, 255, 0.2);
    }
    100% {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }

  @keyframes secondBall {
    0% {
      background-color: rgba(255, 255, 255, 0.2);
    }
    25% {
      background-color: rgba(255, 255, 255, 0.2);
    }
    50% {
      background-color: rgba(255, 255, 255, 1);
    }
    75% {
      background-color: rgba(255, 255, 255, 0.2);
    }
    100% {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }

  @keyframes thirdBall {
    0% {
      background-color: rgba(255, 255, 255, 0.2);
    }
    25% {
      background-color: rgba(255, 255, 255, 0.2);
    }
    50% {
      background-color: rgba(255, 255, 255, 0.2);
    }
    75% {
      background-color: rgba(255, 255, 255, 1);
    }
    100% {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }
`;
